import { RequestMerchant, ReturnItem } from '../../types/order';

export default function getReturnMerchants(
  merchants: Array<RequestMerchant>,
  itemsForReturn: Array<Pick<ReturnItem, 'sku'>>
): Array<number> {
  const eligibleMerchants: Array<number> = [];

  if (merchants) {
    itemsForReturn.forEach(item => {
      let hasSpecificMerchantHandlingReturn = false;
      merchants.every(merchant => {
        if (merchant.items) {
          merchant.items.forEach(merchantItem => {
            if (item.sku === merchantItem.sku) {
              eligibleMerchants.push(merchant.merchant_id);
              hasSpecificMerchantHandlingReturn = true;
              return false;
            }
            return true;
          });
        }
        if (hasSpecificMerchantHandlingReturn) {
          return false;
        }
        return true;
      });

      if (!hasSpecificMerchantHandlingReturn) {
        merchants.forEach(m => {
          if (!m.items) {
            eligibleMerchants.push(m.merchant_id);
          }
        });
      }
    });
  }

  return [...new Set(eligibleMerchants)];
}
